import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonDirective } from 'primeng/button';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'd2d-root-home-skeleton',
  imports: [Skeleton, ButtonDirective, RouterLink],
  templateUrl: './root-home-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './root-home-skeleton.component.scss',
})
export class RootHomeSkeletonComponent {
  protected readonly heroStats = [1, 2, 3];
  protected readonly serviceCards = [1, 2, 3, 4];
  protected readonly faqItems = [1, 2, 3, 4, 5];
  protected readonly partnerCards = [1, 2, 3];
}
